var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.80104 9.80015L7.37622 7.67773L0.443359 13.6208C0.695362 13.8546 1.03556 14.0002 1.41077 14.0002H18.1913C18.5651 14.0002 18.9039 13.8546 19.1545 13.6208L12.2259 7.67773L9.80104 9.80015Z",
    fill: "#777777"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.161 0.379403C18.909 0.144201 18.5702 0 18.1936 0H1.41303C1.03923 0 0.700428 0.145601 0.448425 0.382203L9.80331 8.40007L19.161 0.379403Z",
    fill: "#777777"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.22852V12.8598L6.76626 7.10997L0 1.22852Z",
    fill: "#777777"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.835 7.11026L19.6012 12.8601V1.22461L12.835 7.11026Z",
    fill: "#777777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageGrey);
export default __webpack_public_path__ + "static/media/message-grey.d4f7f582a50fc9284c0a3780f7628da4.svg";
export { ForwardRef as ReactComponent };